import { render, staticRenderFns } from "./admin-featured-item.vue?vue&type=template&id=3c950a91&scoped=true&"
import script from "./admin-featured-item.vue?vue&type=script&lang=js&"
export * from "./admin-featured-item.vue?vue&type=script&lang=js&"
import style0 from "./admin-featured-item.vue?vue&type=style&index=0&id=3c950a91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c950a91",
  null
  
)

export default component.exports